import { cloudChiprApi } from "../../../../../../services/cloudchipr.api";
import { getFetchCostByCategoryWidgetDataThunkFixedCacheKey } from "../../../../utils/helpers/fixedCahcheKeys";

export const postUsersMeOrganisationsCurrentWidgetsCostByCategorySelector = (
  id: string,
) =>
  cloudChiprApi.endpoints.postUsersMeOrganisationsCurrentWidgetsCostByCategory.select(
    getFetchCostByCategoryWidgetDataThunkFixedCacheKey(id),
  );
